module.exports = __webpack_public_path__ + "media/images/og-brodno-b178d229bbbbbf00ea281981c7fd27df.jpg";